/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

export const Trending = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' { ...props }>
		<path d='M23.25 5.25c.414 0 .75.336.75.75v6c0 .414-.336.75-.75.75-.38 0-.693-.282-.743-.648L22.5 12V7.81l-8.47 8.47c-.266.267-.683.29-.976.073l-.084-.073-3.94-3.94-7.22 7.22c-.293.293-.767.293-1.06 0-.267-.267-.29-.684-.073-.977l.073-.084 7.75-7.75c.266-.266.682-.289.976-.072l.084.073 3.94 3.94L21.69 6.75H17.5c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743l.102-.007h5.75z' />
	</svg>
);
